import { QUERY_PERSIST_KEY } from "@/services/query";

export const CURRENT_USER_PROFILE_QUERY_KEY = [
  "users",
  "current",
  "profile",
  QUERY_PERSIST_KEY,
];
